export default "__VITE_ASSET__DxrXCZAP__"